export const PROJETS_PAGE = {
  title: "Grands projets",
  eyebrow: "Aménagement & avenir",
  description:
    "Retrouvez les opérations structurantes de la commune : équipements, espaces publics, mobilités, rénovation urbaine et projets d’avenir.",
  heroImageUrl:
    "https://www.alkern.fr/wp-content/uploads/2021/02/amenagement-urbain.jpg",
  crumbs: [
    { label: "Accueil", href: "/" },
    { label: "Ma Ville" },
    { label: "Grands projets" },
  ],
};